import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import { Loader2 } from 'lucide-react'
import { useTheme } from '@/context/ThemeContext'
import { resolvePostLoginRoute } from '@/lib/resolvePostLoginRoute'
import { CompanyProfileBanner } from '@/features/company-profile'

interface Props {
  children: React.ReactNode
}

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const { currentTheme } = useTheme()
  const navigate = useNavigate()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const token = Cookies.get('token')
    if (!token) {
      navigate('/login', { replace: true })
      return
    }
    resolvePostLoginRoute().then(({ path, state }) => {
      if (path !== '/dashboard') {
        navigate(path, { replace: true, state })
      } else {
        setReady(true)
      }
    })
  }, [navigate])

  if (!ready) {
    return (
      <div
        className="h-screen flex items-center justify-center"
        style={{ backgroundColor: currentTheme.primary }}
      >
        <Loader2 size={32} className="animate-spin" style={{ color: currentTheme.accent }} />
      </div>
    )
  }

  // Pages each own a `h-full` root (viewport height is claimed here instead)
  // so the banner can sit above them as a shrink-0 flex item without any
  // page overflowing its slot.
  return (
    <div className="h-[100dvh] flex flex-col overflow-hidden">
      <CompanyProfileBanner />
      <div className="flex-1 min-h-0 overflow-hidden">
        {children}
      </div>
    </div>
  )
}

export default ProtectedRoute
